import { gql } from "@apollo/client";
export const GET_INVENTORY_LIST = gql`
  query GetInventory($data: getInventoryInput) {
    getInventory(data: $data) {
      message
      status
      inventoryList {
        id
        status
        name
        category
        employeeId
        employeeName
        assignedDate
        description
        usage
      }
    }
  }
`;

const GET_Employee_DASHBOARD = gql`
  query getEmployeeDashboard($data: EmployeeDashboardInput) {
    getEmployeeDashboard(data: $data) {
      message
      earnings
      cashEarnings
      totalServices {
        price
        totalPrice
        address
        bookingDate
        paymentType
        status
        timeSlot
        totalTime
        bookingId
        orderDetail {
          id
          name
          price
        }
        employee {
          id
          fullName
        }
      }
    }
  }
`;
const GET_BOOKINGS = gql`
  mutation getBookings($data: BookingsFilterInput) {
    getBookings(data: $data) {
      status
      message
      orders {
        id
        price
        totalPrice
        status
        address
        bookingDate
        timeSlot
        paymentStatus
        pincode
        paymentType
        verificationStatus
        femaleTimeSlot
        bookingId
        bookingType
        adminPriceAdjustment
        adminPriceAdjustmentReason
        couponDiscount
        codCharges
        couponCode
        reason
        confirmedAt
        headedToLocation
        reachedLocation
        serviceStarted
        serviceScanned
        serviceFinished
        cancelledAt
        forceScan
        inventoryScanStatus
        orderDetail {
          id
          name
          serviceId
          price
          specialPrice
          firstTimePrice
          cutPrice
          count
          type
        }
        employee {
          id
          fullName
        }
        user {
          id
          fullName
          contactNumber
        }
      }
    }
  }
`;
const UPDATE_EMPLOYEE = gql`
  mutation updateAdminEmployee($data: UpdateEmployeeInput!) {
    updateAdminEmployee(data: $data) {
      status
      message
    }
  }
`;

const GET_BLOCKED_SLOTS = gql`
  query getBlockedSlots($data: BlockedSlotsFilter) {
    getBlockedSlots(data: $data) {
      blockedSlots {
        id
        startSlot
        endSlot
        date
        reason
      }
      bookedSlots {
        startSlot
        endSlot
        reason
      }
    }
  }
`;
const UPDATE_ORDER_PAYMENT = gql`
  mutation updateOrderPayment($data: updateServiceInput!) {
    updateOrderPayment(data: $data) {
      status
      message
    }
  }
`;

const SETTLE_PAYMENTS = gql`
  mutation settlePayments($data: SettlePaymentsInput!) {
    settlePayments(data: $data) {
      status
      message
      settledCount
      totalAmount
    }
  }
`;

const GET_ORDER_PAYMENTS = gql`
  mutation getEmployeePayments($data: EarningInput) {
    getEmployeePayments(data: $data) {
      settledPaymentsByDate {
        date
        payments {
          id
          timeSlot
          paymentType
          bookingDate
          settleStatus
          price
          settlementAmount
          settlementMethod
        }
      }
      unSettledPaymentsByDate {
        date
        payments {
          id
          timeSlot
          paymentType
          bookingDate
          settleStatus
          price
          settlementAmount
          settlementMethod
        }
      }
      unsettledCash
      settledCash
      settledOnline
    }
  }
`;
const EMPLOYEE_INVENTORY = gql`
  mutation getEmployeeInventory($data: EmployeeInventoryInput) {
    getEmployeeInventory(data: $data) {
      status
      message
      inventoryList {
        id
        usage
        name
        minStock
        parts
        items
      }
      requestedInventoryCategories {
        categoryId
        catName
        parts
        minStock
        count
        inventoryIds
        inventoryNames
        isScanRequired
      }
      inventoriesByDate {
        date
        inventoryList {
          categoryId
          catName
          parts
          minStock
          count
          inventoryIds
          inventoryNames
          isScanRequired
        }
      }
    }
  }
`;

const VERIFY_BOOKING = gql`
  mutation verifyBooking($data: verifyBookingInput) {
    verifyBooking(data: $data) {
      status
      message
      order {
        id
        price
        totalPrice
        status
        address
        bookingDate
        timeSlot
        paymentStatus
        pincode
        paymentType
        verificationStatus
        femaleTimeSlot
        bookingId
        bookingType
        adminPriceAdjustment
        adminPriceAdjustmentReason
        couponDiscount
        codCharges
        couponCode
        orderDetail {
          id
          name
          serviceId
          price
          specialPrice
          firstTimePrice
          cutPrice
          count
          type
        }
        employee {
          id
          fullName
        }
        user {
          id
          fullName
          contactNumber
        }
      }
    }
  }
`;
const GET_EMPLOYEE_FEEDBACK_ANALYTICS = gql`
  query getEmployeeFeedbackAnalytics(
    $employeeIds: [ID!]
    $startDate: String
    $endDate: String
  ) {
    getEmployeeFeedbackAnalytics(
      employeeIds: $employeeIds
      startDate: $startDate
      endDate: $endDate
    ) {
      status
      message
      data {
        averageRating
        totalFeedbacks
        ratingDistribution
        questionsAnalytics {
          questionId
          question
          answerType
          selectedOptionsCount
        }
      }
    }
  }
`;

const GET_ORDER_FEEDBACK_BY_ORDER = gql`
  query getOrderFeedbackByOrder($orderIds: [ID!]!) {
    getOrderFeedbackByOrder(orderIds: $orderIds) {
      status
      message
      data {
        id
        orderId
        adminToEmployeeRating
        adminToEmployeeComment
        userToEmployeeRating
        userToEmployeeComment
        answers {
          id
          selectedOptions
          question {
            id
            question
            answerType
          }
        }
        order {
          bookingId
          bookingDate
          timeSlot
          address
        }
      }
    }
  }
`;

export {
  GET_Employee_DASHBOARD,
  UPDATE_EMPLOYEE,
  GET_BLOCKED_SLOTS,
  UPDATE_ORDER_PAYMENT,
  SETTLE_PAYMENTS,
  VERIFY_BOOKING,
  GET_ORDER_PAYMENTS,
  EMPLOYEE_INVENTORY,
  GET_BOOKINGS,
  GET_EMPLOYEE_FEEDBACK_ANALYTICS,
  GET_ORDER_FEEDBACK_BY_ORDER,
};
export const ASSIGN_INVENTORY_TO_EMPLOYEE = gql`
  mutation AssignInventoryToEmployee($data: AssignInventoryToEmployeeInput!) {
    assignInventoryToEmployee(data: $data) {
      status
      message
      assignedCount
      assignedQty
      warnings
    }
  }
`;
